var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronLeftFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m9.358 12.007 7.737 7.752q.394.395.382.923-.013.527-.408.923a1.26 1.26 0 0 1-.921.395q-.526 0-.921-.395L7.122 13.51a2.1 2.1 0 0 1-.474-.712 2.1 2.1 0 0 1-.158-.791q0-.395.158-.791.157-.396.474-.712l8.105-8.121A1.23 1.23 0 0 1 16.16 2q.54.014.934.41.395.394.395.922t-.395.923z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeftFill);
export default __webpack_public_path__ + "static/media/chevron_left_fill.22167ce6464c28d98b6541ff81902ee2.svg";
export { ForwardRef as ReactComponent };